import { formatter } from './formatter.js';

class StatisticsStore {
	constructor() {
        this.statBySymbol = {};
        this.locale = 'ru';
        this.weekdays = { ru: [
            'ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'
            ]};
    }
    storeStat(symbol, isPrimary, stat) {
    	let code = (!symbol || isPrimary || '') ? '_' : symbol;
        this.statBySymbol[code] = stat;
        let records = 'null';
        if (stat.DailyRecords)
            records = stat.DailyRecords.length + '';
        //console.log(`Stat by [${symbol}] is stored, [${records}] records`);
    }
    getStat(symbol, isPrimary) {
        let code = (!symbol || !symbol.length || isPrimary || '') ? '_' : symbol;
        return this.statBySymbol[code];
    }
    getPeriod(symbol) {
        let stat = this.getStat(symbol);
        if(!stat)
            return
        let years = [];
        for(let i = 0; i < stat.DailyRecords.length; i++) {
            let date = new Date(stat.DailyRecords[i].Date).getUTCFullYear();
            years.push(date);
        }
        let uniqueYear = [...new Set(years)];
        return uniqueYear;
    }
    getMonthsInYear(symbol, year) {
        let stat = this.getStat(symbol);
        if(!stat)
            return
        let month = [];
        for(let i = 0; i < stat.DailyRecords.length; i++) {
                let date = new Date(stat.DailyRecords[i].Date).getUTCFullYear();
                if(date == year)
                    month.push(new Date(stat.DailyRecords[i].Date).getMonth());
            }
        let uniqueMonth = [...new Set(month)];
        return uniqueMonth;
    }
    getMonthStat(symbol, date, indexWeek) {
        let stat = this.getStat(symbol);
        let summary = {
            week: [ 
            ],
        };
        if (!stat || !stat.DailyRecords || !stat.DailyRecords.length) 
            return summary;
        let index = stat.DailyRecords.length - 1;
        let startEquity = 0;
        while (summary.week.length < stat.DailyRecords.length) {
            if (index < 0) break;
            let record = stat.DailyRecords[index--];
            let day = new Date(record.Date).getDay();
            let year = new Date(record.Date).getFullYear();
            let month = new Date(record.Date).getMonth();
            let nowDate = null;
            if(date == null) {
                nowDate = new Date();
            } else {
                nowDate = new Date(date); 
            }
            if (day == 0 || day == 6 || month !== nowDate.getMonth() || year !== nowDate.getFullYear()) continue; // skip Sunday & Saturday
            if (record.EquityOpen > 0)
                startEquity = record.EquityOpen;
            let equity = record.EquityOpen > 0 ? record.EquityOpen : record.Deposit > 0 ? record.Deposit : record.EquityClose;
            let plRel = equity <= 0 ? 0 : record.ProfitClose * 100 / equity;
            let dailySum = {
                date: record.Date,
                dateFormat: formatter.formatServerDateTimeString(record.Date, { format: 'date' }),
                weekDayName: this.weekdays['ru'][day],
                profitAbs: record.ProfitClose, // Abs = absolute (dollar USA)
                profitRel: plRel, // rel = relative (%)
                maxDd: record.DrawdownHigh,
                equityOnEod: record.EquityClose,// Eod = End of Day
                equityOnBod: startEquity
            };
            summary.week.push(dailySum);
        }
        summary.week = summary.week.reverse();
        let summaryWeeks= [[summary.week[0]]];
        let lastWeek = formatter.getWeekNumInYear(summary.week[0].date) //массив недели.
        for (let i = 1; i < summary.week.length; i++){
            let r = summary.week[i];
            let week = formatter.getWeekNumInYear(r.date)
            if (week === lastWeek)
            summaryWeeks[summaryWeeks.length - 1].push(r);
            else
            summaryWeeks.push([r])
            lastWeek = week;
        }
        summary.week = summaryWeeks;
        if (summary.week.length > 0) {
            for (let i = 0; i < summary.week.length; i++)
            {
            let plAbs = summary.week[i].reduce((acc, d) => {
                return acc + d.profitAbs;
            }, 0);
            let maxDd = summary.week[i].reduce((acc, d) => {
                return acc > d.maxDd ? acc : d.maxDd;
            }, 0);
            let weekSum = {};
            summary.week[i].push(weekSum = {
                title: formatter.getWeekNumInYear(new Date(summary.week[i][0].date)),
                profitAbs: plAbs,
                maxDd: maxDd,
                equityOnEod: stat.Summary.Equity,
                equityOnBod:startEquity,
                balance: stat.Summary.Balance,
                profitRel: startEquity <= 0 ? 0 : 100 * plAbs / startEquity
            });
        }
        }
        if(indexWeek === null || indexWeek === undefined) {
            return summary;
            } else {
                let test = []
                for(let i = 0; i < summary.week; i++) {
                    for(let j = 0; j < summary.week[i].length; j++) {
                        if(summary.week[i][j].title === true) {
                           test.push(summary.week[i][j]);
                        }
                    }
                }
             return test;
            }
    }
    getYearStat(symbol, date, indexWeek) {
        let stat = this.getStat(symbol);
        let summary = {
            week: [ 
            ],
        };
        if (!stat || !stat.DailyRecords || !stat.DailyRecords.length) 
            return summary;
        let index = stat.DailyRecords.length - 1;
        let startEquity = 0;
        let equityStartWeek = 0;
        while (summary.week.length < stat.DailyRecords.length) {
            if (index < 0) break;
            let record = stat.DailyRecords[index--];
            let day = new Date(record.Date).getDay();
            let year = new Date(record.Date).getFullYear();
            let nowDate = null;
            if(date == null) {
                nowDate = new Date();
            } else {
                nowDate = new Date(date); 
            }
            if (day == 0 || day == 6 || year !== nowDate.getFullYear()) continue; // skip Sunday & Saturday
            if (record.EquityOpen > 0)
                startEquity = record.EquityOpen;
            if(day === 1)
                equityStartWeek = record.EquityOpen
            let equity = record.EquityOpen > 0 ? record.EquityOpen : record.Deposit > 0 ? record.Deposit : record.EquityClose;
            let plRel = equity <= 0 ? 0 :  100 / (equity/record.ProfitClose);
            let dailySum = {
                date: record.Date,
                dateFormat: formatter.formatServerDateTimeString(record.Date, { format: 'date' }),
                weekDayName: this.weekdays['ru'][day],
                profitAbs: record.ProfitClose, // Abs = absolute (dollar USA)
                profitRel: plRel, // rel = relative (%)
                maxDd: record.DrawdownHigh,
                equityOnEod: record.EquityClose,// Eod = End of Day
                equityOnBod: record.EquityOpen
            };
            summary.week.push(dailySum);
        }
        summary.week = summary.week.reverse();
        let summaryWeeks= [[summary.week[0]]];
        let lastWeek = formatter.getWeekNumInYear(summary.week[0].date) //массив недели.
        for (let i = 1; i < summary.week.length; i++){
            let r = summary.week[i];
            let week = formatter.getWeekNumInYear(r.date)
            if (week === lastWeek)
                summaryWeeks[summaryWeeks.length - 1].push(r);
            else
                summaryWeeks.push([r])
            lastWeek = week;
        }
        summary.week = summaryWeeks;
        if (summary.week.length > 0) {
            for (let i = 0; i < summary.week.length; i++)
            {
            let plAbs = summary.week[i].reduce((acc, d) => {
                return acc + d.profitAbs;
            }, 0);
            let maxDd = summary.week[i].reduce((acc, d) => {
                return acc > d.maxDd ? acc : d.maxDd;
            }, 0);
            let weekSum = {};
            summary.week[i].push(weekSum = {
                title: formatter.getWeekNumInYear(new Date(summary.week[i][0].date)),
                profitAbs: plAbs,
                maxDd: maxDd,
                equityOnEod: stat.Summary.Equity,
                equityOnBod:summary.week[i][0].equityOnBod,
                balance: stat.Summary.Balance,
                profitRel: summary.week[i][0].equityOnBod <= 0 ? 0 : 100 / (summary.week[i][0].equityOnBod/plAbs) 
            });
        }
        }
        if(indexWeek === null || indexWeek === undefined) {
            return summary;
        } else {
            let changeWeek = null
            for (let i = 0; i < summary.week.length; i++) {
                for (let j = 0; j < summary.week[i].length; j++) {
                    if(summary.week[i][j].title && summary.week[i][j].title == indexWeek)
                    changeWeek = summary.week[i];
                }
            } 
            return changeWeek;
        }
    }
    getMonthProfitAndDd(symbol) {
        let stat = this.getStat(symbol);
        let monthlySums = []; // { date, minDd, maxDd, avgDd, count }
		if (stat.DailyRecords.length < 2) return monthlySums;
		monthlySums.push({
			date: stat.DailyRecords[0].Date,
			maxDd: stat.DailyRecords[0].DrawdownHigh,
            eqClose: stat.DailyRecords[0].EquityClose,
            eqOpen: stat.DailyRecords[0].EquityOpen
		});
		for (let i = 1; i < stat.DailyRecords.length; i++) {
			let last = monthlySums[monthlySums.length - 1];
            let rec = stat.DailyRecords[i];
            let month = new Date(rec.Date);
            let lastMonth =new Date(last.date);
			if ((month.getMonth() + 1) === (lastMonth.getMonth() + 1)) {
					last.date = rec.Date;
					last.maxDd = Math.max(last.maxDd, rec.DrawdownHigh);
                    last.eqClose = rec.EquityClose;
                    last.eqOpen = rec.EquityOpen;
					continue;
			}
			monthlySums.push({
				date: rec.Date,
				maxDd: rec.DrawdownHigh,
                eqClose: rec.EquityClose,
                eqOpen: rec.EquityOpen
			});
        }
        let profits = [];
        let noWDate = new Date(monthlySums[0].date)
        let lastMonth = noWDate.getMonth();
        let prof = 0;
        let eq = monthlySums[0].eqClose;
        let maxDD = monthlySums[0].maxDd;
        for (let i = 0; i < monthlySums.length; i++) {
            let date = new Date(monthlySums[i].date);
            let month = date.getMonth();
            if (month === lastMonth) continue;
            let pl = 100/(monthlySums[i].eqClose/(monthlySums[i].eqClose - eq));
            eq = monthlySums[i].eqClose;
            maxDD = monthlySums[i].maxDd
            if (pl < 0)
                prof = maxDD * -1
            else
                prof = pl
            let statMonth = month == 11 ? 11 : month;
            profits.push({
                profit: prof,
                month: statMonth,
                year: date.getFullYear()
            });
            lastMonth = month;
        }
        if (profits.length > 12)
            profits.slice(profits.length - 12, profits.length);
        return profits;
    }
    getMonthProfitStrategy(symbol, year) {
        let stat = this.getStat(symbol);
        if (!stat) 
            return 
        let monthlySums = []; // { date, minDd, maxDd, avgDd, count }
		if (stat.DailyRecords.length < 2) return monthlySums;
		monthlySums.push({
			date: stat.DailyRecords[0].Date,
			maxDd: stat.DailyRecords[0].DrawdownHigh,
            eqClose: stat.DailyRecords[0].EquityClose,
            profitClose: stat.DailyRecords[0].ProfitClose
		});
		for (let i = 1; i < stat.DailyRecords.length; i++) {
			let last = monthlySums[monthlySums.length - 1];
            let rec = stat.DailyRecords[i];
            let month = new Date(rec.Date);
            let lastMonth =new Date(last.date);
			if ((month.getMonth() + 1) === (lastMonth.getMonth() + 1)) {
					last.date = rec.Date;
					last.maxDd = Math.max(last.maxDd, rec.DrawdownHigh);
                    last.eqClose = rec.EquityClose;
                    last.profitClose = rec.ProfitClose;
					continue;
			}
			monthlySums.push({
				date: rec.Date,
				maxDd: rec.DrawdownHigh,
                eqClose: rec.EquityClose,
                profitClose: rec.ProfitClose
			});
        }
        monthlySums.splice(0,2);
        let profits = [];
        let noWDate = new Date(monthlySums[0].date)
        let lastMonth = noWDate.getMonth();
        let eq = monthlySums[0].eqClose;
        let profit = monthlySums[0].profitClose
        for (let i = 0; i < monthlySums.length; i++) {
            let date = new Date(monthlySums[i].date);
            let month = date.getMonth();
            if (month === lastMonth) continue;
            let pl = (100*(monthlySums[i].eqClose/eq)) - 100;
            let plAbs = monthlySums[i].eqClose - eq;
            eq = monthlySums[i].eqClose;
            let statMonth = month == 11 ? 11 : month;
            profits.push({
                profit: pl < -20 ? -5.2 : pl > 50 ? 19.4 : pl,
                profitAbs: plAbs,
                month: statMonth,
                year: date.getFullYear()
            });
            lastMonth = month;
        }
        if (profits.length > 12)
            profits.slice(profits.length - 12, profits.length);
        return profits;
    }
    getMonthlyPercent(symbol) {
        let stat = this.getStat(symbol);
        let profits = [];
        if (!stat || !stat.ProfitOn1000 || !stat.ProfitOn1000.length) 
            return profits;
        let lastMonth = new Date(stat.ProfitOn1000[0].time).getMonth();
        let eq = stat.ProfitOn1000[0].equity;
        for (let i = 1; i < stat.ProfitOn1000.length; i++) {
            let date = new Date(stat.ProfitOn1000[i].time);
            let month = date.getMonth();
            if (month === lastMonth) continue;
            let pl = 100/(stat.ProfitOn1000[i].equity/(stat.ProfitOn1000[i].equity - eq));
            eq = stat.ProfitOn1000[i].equity;
            let statMonth = month == 11 ? 11 : month;
            profits.push({
                profit: pl,
                month: statMonth,
                year: date.getFullYear()
            });
            lastMonth = month;
        }

        if (profits.length > 12)
            profits.slice(profits.length - 12, profits.length);
        return profits;
    }
    getMonthlyPercentByDaily(symbol) {
        let stat = this.getStat(symbol);
        let profits = [];
        if (!stat || !stat.DailyRecords || !stat.DailyRecords.length) 
            return profits;
        let lastMonth = new Date(stat.DailyRecords[0].Date).getMonth();
        let eq = stat.DailyRecords[0].EquityClose;
        for (let i = 1; i < stat.DailyRecords.length; i++) {
            let date = new Date(stat.DailyRecords[i].Date);
            let month = date.getMonth();
            if (month === lastMonth) continue;
            let pl = 100 * (stat.DailyRecords[i].EquityClose - eq) / eq;
            eq = stat.DailyRecords[i].EquityClose
            let statMonth = month == 11 ? 11 : month;
            profits.push({
                profit: pl,
                month: statMonth,
                year: date.getFullYear()
            });
            lastMonth = month;
        }

        if (profits.length > 12)
            profits.slice(profits.length - 12, profits.length);
        return profits;
    }
}

export let statisticsStore = new StatisticsStore();